var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 83,
    viewBox: "0 0 80 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3415_16365)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5922 24.8197C52.2024 23.7587 52.5517 22.5269 52.5517 21.2131C52.5517 17.2294 49.3405 14 45.3793 14C42.9787 14 40.8536 15.186 39.5517 17.0072C38.2498 15.186 36.1247 14 33.7241 14C29.7629 14 26.5517 17.2294 26.5517 21.2131C26.5517 22.5269 26.901 23.7587 27.5113 24.8197H16.6897C15.2042 24.8197 14 26.0307 14 27.5246V37.4426C14 38.9365 15.2042 40.1475 16.6897 40.1475H19.3793V66.2951C19.3793 67.789 20.5835 69 22.069 69H57.931C59.4165 69 60.6207 67.789 60.6207 66.2951V40.1475H63.3103C64.7958 40.1475 66 38.9365 66 37.4426V27.5246C66 26.0307 64.7958 24.8197 63.3103 24.8197H51.5922ZM43.5862 21.2131C43.5862 20.2172 44.389 19.4098 45.3793 19.4098C46.3696 19.4098 47.1724 20.2172 47.1724 21.2131C47.1724 22.209 46.3696 23.0164 45.3793 23.0164C44.389 23.0164 43.5862 22.209 43.5862 21.2131ZM33.7241 19.4098C32.7338 19.4098 31.931 20.2172 31.931 21.2131C31.931 22.209 32.7338 23.0164 33.7241 23.0164C34.7144 23.0164 35.5172 22.209 35.5172 21.2131C35.5172 20.2172 34.7144 19.4098 33.7241 19.4098ZM37.3103 28.4262C37.3103 27.4303 38.1131 26.623 39.1034 26.623H40.8966C41.8869 26.623 42.6897 27.4303 42.6897 28.4262V30.2295H60.6207C61.611 30.2295 62.4138 31.0369 62.4138 32.0328V33.8361C62.4138 34.832 61.611 35.6393 60.6207 35.6393H42.6897V63.5902C42.6897 64.5861 41.8869 65.3934 40.8966 65.3934H39.1034C38.1131 65.3934 37.3103 64.5861 37.3103 63.5902V35.6393H19.3793C18.389 35.6393 17.5862 34.832 17.5862 33.8361V32.0328C17.5862 31.0369 18.389 30.2295 19.3793 30.2295H37.3103V28.4262Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3415_16365",
    x: 0,
    y: 0,
    width: 80,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.490196 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3415_16365"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3415_16365",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.dd8679e4c17b1419deebfcb2715d7e3a.svg";
export { ForwardRef as ReactComponent };